/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/qs1/"

const QS1: CommunityData = {
  code: "qs1",
  inviteCode: "qs1",
  name: "QS1",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "EUR",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/qso-001`,
  waitlist: false,
  socials: {},
  styles: {
    global: {
      counterColor: "#000000",
      logo: {
        src: "https://media.werz.at/community/icon/cmnzxijq800009kkvtnvgl32q.jpg?uploadTime=1776278934983&type=image",
        styles: "w-[96px] h-[96px] object-contain",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[160px] h-[41px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#ffffff",
      asideBg: "#ffffff",
      asideStyles: "border-r border-[#d5d5d5]",
      contentBg: "#ffffff",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.mp4?type=video`,
      bgMobile: `${S3_PREFIX}web-background-mobile.mp4?type=video`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.mp4?type=video`,
      mainFont: "font-['GeistRegular']",
      primaryButton:
        "bg-[#ffffff] border border-[#000000] px-[18px] py-[18px] !text-[#000000] font-['GeistMonoRegular'] !text-[16px] uppercase text-left leading-[100%]",
    },
    navigation: {
      iconsColor: "#000000",
      sideBarSeparator: "border-r-[1px] border-[#d5d5d5]",
      separator: "border-[#d5d5d5]",
      item: "font-['GeistMonoRegular'] text-[15px] text-[#000000] uppercase text-left leading-[100%] gap-x-[10px] text-opacity-50 text-center border-b border-[#d5d5d5] !pl-0 !py-3",
      itemSelected: " !text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#ffffff] !pb-8",
      titles:
        "text-[#000000] font-['GeistMonoRegular'] text-[24px] uppercase text-left leading-[110%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#8d8d8d] font-['GeistRegular'] text-[14px] text-left leading-[130%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#d5d5d5]",
        sectionTitle:
          "text-[#000000] font-['GeistMonoRegular'] text-[24px] uppercase text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#ffffff]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title:
            "text-[#000000] font-['GeistMonoRegular'] text-[14px] uppercase text-left leading-[110%]",
          subtitle:
            "text-[#8d8d8d] font-['GeistRegular'] text-[11px] text-left leading-[130%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#d5d5d5]",
        sectionTitle:
          "text-[#000000] font-['GeistMonoRegular'] text-[24px] uppercase text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#ffffff]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full !aspect-video bg-gray-400",
          content: "flex flex-col px-4 bg-transparent",
          title:
            "text-[#000000] font-['GeistMonoRegular'] text-[14px] uppercase text-left leading-[110%]",
          subtitle:
            "text-[#8d8d8d] font-['GeistRegular'] text-[11px] text-left leading-[130%] mt-2",
          location:
            "text-[#8d8d8d] font-['GeistRegular'] text-[11px] text-left leading-[130%] mt-1",
          date: "text-[#8d8d8d] font-['GeistRegular'] text-[11px] text-left leading-[130%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title:
          "text-[#000000] font-['GeistMonoRegular'] text-[22px] uppercase text-left leading-[110%]",
        text: "text-[#000000] font-['GeistRegular'] text-[12px] text-left leading-[130%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#000000] font-['GeistMonoRegular'] text-[24px] uppercase text-left leading-[110%] !mb-4 sm:mb-6",
      },
    },
    comingSoon: {
      bgColor: "#ffffff",
      hero: {
        desktop: `${S3_PREFIX}web-background.mp4?type=video`,
        mobile: `${S3_PREFIX}web-background-mobile.mp4?type=video`,
        style: "bg-[#C8C8C8]",
      },
      logo: {
        desktop: `${S3_PREFIX}web-alternative-logo.png`,
        mobile: `${S3_PREFIX}web-alternative-logo.png`,
        style: "w-[130px] sm:w-[160px]",
      },
      werzLogoColor: "#191818",
      title: "font-['GeistMonoRegular'] text-[28px] leading-[120%] text-[#000000]",
      text: "font-['GeistRegular'] text-[16px] leading-[120%] text-[#000000]",
      button:
        "font-['GeistMonoRegular'] text-[16px] leading-[120%] p-4 bg-[#ffffff] border border-[#000000] text-[#000000] uppercase cursor-pointer w-fit",
      input: {
        base: "font-['GeistRegular'] text-[14px] leading-[120%] w-[256px] px-4 h-[48px] bg-white",
        border: "#D4D4D4",
        borderFocus: "#000000",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error: "font-['GeistRegular'] text-[14px] leading-[120%] text-[#FF0000]",
      footerText: "font-['GeistRegular'] text-[14px] leading-[120%] text-[#8D8D8D]",
      skipButton: "font-['GeistRegular'] text-[14px] leading-[120%] text-[#8D8D8D] cursor-pointer",
      modal: {
        container: "bg-[#F0F0F0] px-[40px] py-[48px]",
        title: "font-['GeistMonoRegular'] text-[24px] leading-[120%] text-[#000000] text-center",
        text: "font-['GeistRegular'] text-[14px] leading-[120%] text-[#8D8D8D] text-center",
        width: "w-[358px]",
        backdrop: "bg-black/50",
        otpInput:
          "!w-[40px] !h-[50px] rounded-[4px] text-black bg-white font-['GeistRegular'] text-[16px] leading-[120%] text-center",
        otpBorder: "#D4D4D4",
        otpBorderFocus: "#000000",
      },
    },
    linktree: {
      bgDesktop:
        "https://media.werz.at/community-assets/qs1/web-background-non-member.mp4?type=video",
      bgMobile:
        "https://media.werz.at/community-assets/qs1/web-background-non-member.mp4?type=video",
      bgColor: "#ffffff",
      bgMedia: "object-cover object-center",
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative px-4 py-12 sm:p-[64px] bg-[#ffffff]",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[2.5px] object-cover border border-[#a7a7a7]",
        name: "text-[#ffffff] font-['GeistMonoRegular'] text-[24px] uppercase text-center text-center mt-4 mb-1",
        location: "font-['GeistMonoRegular'] uppercase text-[16px] text-center text-center mb-2",
        description:
          "text-[#000000] font-['GeistRegular'] text-[12px] leading-[130%] text-center text-center mb-4 max-w-[500px]",
        socialMediaIconColor: "#000000",
        button:
          "bg-[#ffffff] border border-[#000000] px-[12px] py-[12px] text-[#000000] font-['GeistMonoRegular'] text-[14px] uppercase text-left leading-[100%] w-fit cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#ffffff] border border-[#a7a7a7] text-[#000000] font-['GeistRegular'] text-[12px] leading-[130%] text-center",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] flex flex-col justify-center items-center p-[34px] mb-[32px] bg-[#ffffff] border border-[#a7a7a7]",
          title: "font-['GeistMonoRegular'] uppercase text-[16px] text-left text-center mb-1",
          text: "text-[#000000] font-['GeistRegular'] text-[12px] leading-[130%] text-center text-center",
          button:
            "bg-[#ffffff] border border-[#000000] px-[12px] py-[12px] text-[#000000] font-['GeistMonoRegular'] text-[14px] uppercase text-left leading-[100%] w-fit cursor-pointer mt-4",
        },
        header:
          "text-[#ffffff] font-['GeistMonoRegular'] uppercase text-[16px] text-left text-center mb-[10px]",
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#ffffff] border border-[#a7a7a7]",
          duration: "text-[#8d8d8d] font-['GeistRegular'] text-[11px] text-left",
          name: "text-[#000000] font-['GeistMonoRegular'] uppercase text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          plusIconColor: "#000000",
          media: "overflow-hidden m-2 border border-[#a7a7a7]",
        },
        event: {
          container: "overflow-hidden sm:w-[500px] w-[95vw] bg-[#ffffff] border border-[#a7a7a7]",
          name: "text-[#000000] font-['GeistMonoRegular'] uppercase text-[16px] text-left mb-1 one-line-truncate sm:w-[370px] w-[60vw]",
          startDate:
            "w-[68px] h-[68px] flex flex-col justify-center items-center gap-1 bg-[#000000] border border-[#6d6d6d] text-[#ffffff] font-['GeistMonoRegular'] text-[14px] uppercase text-center",
          duration: "text-[#8d8d8d] font-['GeistRegular'] text-[11px] text-left",
          location: "text-[#8d8d8d] font-['GeistRegular'] text-[11px] text-left",
          button:
            "bg-[#ffffff] border border-[#000000] px-[12px] py-[12px] text-[#000000] font-['GeistMonoRegular'] text-[14px] uppercase text-left leading-[100%] w-fit cursor-pointer mt-3",
          product: {
            container:
              "min-h-[68px] px-4 py-3 flex justify-between gap-4 border-t border-[#a7a7a7]",
            name: "text-[#000000] font-['GeistMonoRegular'] uppercase text-[14px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
            price: "text-[#000000] font-['GeistMonoRegular'] uppercase text-[14px] text-left",
            link: "text-[#8d8d8d] font-['GeistRegular'] text-[14px] text-left",
            status:
              "text-[#000000] font-['GeistMonoRegular'] uppercase leading-[110%] text-[14px] text-left",
            button:
              "bg-[#ffffff] border border-[#000000] px-[12px] py-[12px] text-[#000000] font-['GeistMonoRegular'] text-[14px] uppercase text-left leading-[100%] w-fit cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[#000000] font-['GeistRegular'] text-[12px] leading-[130%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      news: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#ffffff] border border-[#a7a7a7] text-[#000000] font-['GeistRegular'] text-[12px] leading-[130%] text-center",
        header:
          "text-[#ffffff] font-['GeistMonoRegular'] uppercase text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        oneNews: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#ffffff] border border-[#a7a7a7]",
          name: "text-[#000000] font-['GeistMonoRegular'] uppercase text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#000000",
          created: "text-[#8d8d8d] font-['GeistRegular'] text-[11px] text-left",
          media: "overflow-hidden m-2 border border-[#a7a7a7]",
        },
        seeAllNews:
          "text-[#000000] font-['GeistRegular'] text-[12px] leading-[130%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      radioTracks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#ffffff] border border-[#a7a7a7] text-[#000000] font-['GeistRegular'] text-[12px] leading-[130%] text-center",
        header:
          "text-[#ffffff] font-['GeistMonoRegular'] uppercase text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        radioTrack: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#ffffff] border border-[#a7a7a7]",
          coverUrl: "overflow-hidden m-2 border border-[#a7a7a7]",
          duration: "text-[#8d8d8d] font-['GeistRegular'] text-[11px] text-left",
          liveType: "text-[#8d8d8d] font-['GeistRegular'] text-[11px] text-left",
          liveTypeCircle: "w-2 h-2 bg-[#000000] rounded-full",
          playIconColor: "#ffffff",
          playIconBackgroundColor: "#000000",
          playIconBorderColor: "#ffffff",
          start: "text-[#8d8d8d] font-['GeistRegular'] text-[11px] text-left",
          title:
            "text-[#000000] font-['GeistMonoRegular'] uppercase text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
        },
        seeAllTracks:
          "text-[#000000] font-['GeistRegular'] text-[12px] leading-[130%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      otherLinks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#ffffff] border border-[#a7a7a7] text-[#000000] font-['GeistRegular'] text-[12px] leading-[130%] text-center",
        header:
          "text-[#ffffff] font-['GeistMonoRegular'] uppercase text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-[10px] mb-[40px]",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] w-[95vw] flex justify-between bg-[#ffffff] border border-[#a7a7a7]",
          name: "text-[#000000] font-['GeistMonoRegular'] uppercase text-[16px] text-left",
          triangleIconColor: "#000000",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full object-cover border border-[#a7a7a7]",
        },
      },
      footer: {
        WERZlogoColor: "#000000",
        text: "text-[#8d8d8d] font-['GeistRegular'] text-[11px] text-left",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#ffffff] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#d5d5d5]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 !border-0",
        title:
          "text-[#000000] font-['GeistMonoRegular'] text-[24px] uppercase text-left leading-[110%]",
        subtitle:
          "text-[#8d8d8d] font-['GeistRegular'] text-[14px] text-left leading-[130%] mb-4 mt-2",
        button:
          "bg-[#ffffff] border border-[#000000] px-[18px] py-[18px] gap-y-[6px] !w-fit mb-4 sm:mb-0 text-[#000000] font-['GeistMonoRegular'] !text-[16px] uppercase text-left leading-[100%]",
        questions: "text-[14px] text-left leading-[130%] text-[#000000]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#d5d5d5]",
        header:
          "text-[#000000] font-['GeistMonoRegular'] text-[22px] uppercase text-left leading-[110%]",
        text: "text-[#000000] font-['GeistRegular'] text-[14px] text-left leading-[130%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#d5d5d5]",
        header:
          "text-[#000000] font-['GeistMonoRegular'] text-[22px] uppercase text-left leading-[110%]",
        text: "text-[#000000] font-['GeistRegular'] text-[14px] text-left leading-[130%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden gap-y-[10px]",
        mapPinColor: "#000000",
        mapStrokeColor: "#00000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#000000] font-['GeistMonoRegular'] text-[22px] uppercase text-left leading-[110%]",
        text: "text-[#000000] font-['GeistRegular'] text-[14px] text-left leading-[130%]",
      },
      tickets: {
        header:
          "text-[#000000] font-['GeistMonoRegular'] text-[22px] uppercase text-left leading-[110%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#ffffff] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#ffffff] border border-[#000000] px-[12px] py-[12px] text-[#000000] font-['GeistMonoRegular'] text-[14px] uppercase text-left leading-[100%] !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#ffffff] border-b border-[#d5d5d5] py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#000000] font-['GeistMonoRegular'] text-[14px] uppercase text-left leading-[110%] mb-1",
          description:
            "text-[#8d8d8d] font-['GeistRegular'] text-[14px] text-left leading-[130%] mb-1 flex flex-row",
          price:
            "text-[#8d8d8d] font-['GeistMonoRegular'] text-[14px] uppercase text-left leading-[110%]",
          quantity:
            "text-[#000000] font-['GeistMonoRegular'] text-[14px] uppercase text-left leading-[100%]",
          status:
            "text-[#8d8d8d] font-['GeistMonoRegular'] text-[14px] uppercase text-left leading-[110%]",
          counterContainer:
            "bg-[#ffffff] border border-[#000000] px-[12px] py-[12px] gap-x-[16px] !w-fit !h-10",
          button:
            "bg-[#ffffff] border border-[#000000] px-[12px] py-[12px] text-[#000000] font-['GeistMonoRegular'] text-[14px] uppercase text-left leading-[100%] !w-fit",
          plusMinusColor: "#000000",
        },
      },
    },
  },
}

export default QS1
